import { render } from "./IndicatorInsights.vue?vue&type=template&id=b1052cec&scoped=true"
import script from "./IndicatorInsights.vue?vue&type=script&lang=js"
export * from "./IndicatorInsights.vue?vue&type=script&lang=js"

import "./IndicatorInsights.vue?vue&type=style&index=0&id=b1052cec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1052cec"]])

export default __exports__